/* Polo Club — JS v14 */
(function(){
  'use strict';
  const root = document.querySelector('.polo');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const jsonEl = document.querySelector('[data-product-json="' + sectionId + '"]');
  let product = null;
  try { product = JSON.parse(jsonEl.textContent); } catch(e) {}

  /* ============ ALL PRODUCT IMAGES ============ */
  let allImages = [];
  const galImgEl = document.getElementById('poloGalleryImages');
  if (galImgEl) { try { allImages = JSON.parse(galImgEl.textContent); } catch(e) {} }

  let currentImageIdx = 0;
  let thumbPage = 0;
  const THUMBS_PER_PAGE = 5;

  function renderThumbnails() {
    const thumbsEl = document.getElementById('poloGalleryThumbs');
    if (!thumbsEl || !allImages.length) return;
    const start = thumbPage * THUMBS_PER_PAGE;
    const end = Math.min(start + THUMBS_PER_PAGE, allImages.length);
    thumbsEl.innerHTML = '';
    for (let i = start; i < end; i++) {
      const img = allImages[i];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'polo-gallery__thumb' + (i === currentImageIdx ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === currentImageIdx ? 'true' : 'false');
      btn.dataset.index = i;
      const imgEl = document.createElement('img');
      imgEl.src = img.thumb || img.src;
      imgEl.alt = img.alt || '';
      imgEl.width = 64; imgEl.height = 64; imgEl.loading = 'lazy';
      btn.appendChild(imgEl);
      btn.addEventListener('click', () => showGalleryImage(i));
      thumbsEl.appendChild(btn);
    }
    const tp = document.getElementById('poloThumbPrev');
    const tn = document.getElementById('poloThumbNext');
    if (tp) tp.disabled = thumbPage <= 0;
    if (tn) tn.disabled = end >= allImages.length;
  }

  function showGalleryImage(idx) {
    if (!allImages.length) return;
    idx = ((idx % allImages.length) + allImages.length) % allImages.length;
    currentImageIdx = idx;
    const imgData = allImages[idx];
    const mainImg = document.querySelector('#poloGalleryMain img');
    if (mainImg) { mainImg.src = imgData.src; mainImg.srcset = ''; mainImg.alt = imgData.alt || ''; }
    const neededPage = Math.floor(idx / THUMBS_PER_PAGE);
    if (neededPage !== thumbPage) {
      thumbPage = neededPage;
      renderThumbnails();
    } else {
      document.querySelectorAll('.polo-gallery__thumb').forEach(t => {
        const active = parseInt(t.dataset.index, 10) === idx;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.classList.toggle('is-active', active);
      });
    }
  }

  /* Main image arrows */
  const galPrev = document.getElementById('poloGalleryPrev');
  const galNext = document.getElementById('poloGalleryNext');
  if (galPrev) galPrev.addEventListener('click', () => showGalleryImage(currentImageIdx - 1));
  if (galNext) galNext.addEventListener('click', () => showGalleryImage(currentImageIdx + 1));

  /* Touch swipe on main gallery image */
  const galWrap = document.querySelector('.polo-gallery__main-wrap');
  if (galWrap) {
    let galTouchX = 0, galTouchY = 0;
    galWrap.addEventListener('touchstart', e => {
      galTouchX = e.touches[0].clientX;
      galTouchY = e.touches[0].clientY;
    }, { passive: true });
    galWrap.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - galTouchX;
      const dy = e.changedTouches[0].clientY - galTouchY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      showGalleryImage(currentImageIdx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Thumbnail page arrows */
  const thumbPrev = document.getElementById('poloThumbPrev');
  const thumbNext = document.getElementById('poloThumbNext');
  if (thumbPrev) thumbPrev.addEventListener('click', () => { thumbPage--; renderThumbnails(); });
  if (thumbNext) thumbNext.addEventListener('click', () => { thumbPage++; renderThumbnails(); });

  /* Touch swipe on thumbnail strip */
  const thumbsOuter = document.querySelector('.polo-gallery__thumbs-outer');
  if (thumbsOuter) {
    let thumbTouchX = 0;
    thumbsOuter.addEventListener('touchstart', e => { thumbTouchX = e.touches[0].clientX; }, { passive: true });
    thumbsOuter.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - thumbTouchX;
      if (Math.abs(dx) < 30) return;
      if (dx < 0 && thumbNext && !thumbNext.disabled) { thumbPage++; renderThumbnails(); }
      else if (dx > 0 && thumbPrev && !thumbPrev.disabled) { thumbPage--; renderThumbnails(); }
    }, { passive: true });
  }

  /* Initial thumbnail render */
  if (allImages.length) renderThumbnails();

  /* ============ VARIANT PICKER ============ */
  const selectedOptions = [];
  if (product) {
    product.options.forEach((opt, i) => {
      const current = product.variants.find(v => v.id === product.selected_or_first_available_variant?.id);
      selectedOptions[i] = current ? current.options[i] : product.options[i].values?.[0] || '';
    });
  }

  function findVariant(opts) {
    if (!product) return null;
    return product.variants.find(v => v.options.every((val, i) => val === opts[i]));
  }

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function applyVariant() {
    const variant = findVariant(selectedOptions);
    if (!variant) return;
    const idInput = document.getElementById('poloVariantId');
    if (idInput) idInput.value = variant.id;
    const cta = document.getElementById('poloAddToCart');
    const buyNow = document.getElementById('poloBuyNow');
    if (cta) {
      if (variant.available) {
        cta.removeAttribute('disabled');
        if (buyNow) buyNow.removeAttribute('disabled');
      } else {
        cta.setAttribute('disabled', 'disabled');
        if (buyNow) buyNow.setAttribute('disabled', 'disabled');
        const lbl = cta.querySelector('.polo-cta__label');
        if (lbl) lbl.textContent = 'Esgotado';
      }
    }
    const stickyLabel = document.getElementById('poloStickyVariant');
    if (stickyLabel) stickyLabel.textContent = selectedOptions.join(' · ');
    document.querySelectorAll('[data-option-value-for]').forEach(el => {
      el.textContent = selectedOptions[parseInt(el.dataset.optionValueFor, 10)];
    });
    if (variant.featured_image && allImages.length) {
      const fi = variant.featured_image;
      const matchIdx = allImages.findIndex(img => img.id === fi.id);
      if (matchIdx >= 0) {
        showGalleryImage(matchIdx);
      } else {
        const mainImg = document.querySelector('#poloGalleryMain img');
        if (mainImg) {
          mainImg.src = (fi.src || '').replace(/(\.[^.?]+)(\?.*)?$/, '_1200x1200$1$2');
          mainImg.srcset = '';
        }
      }
    }
  }

  document.querySelectorAll('.polo-swatch, .polo-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const sel = btn.classList.contains('polo-swatch') ? '.polo-swatch' : '.polo-size-btn';
      btn.closest('.polo-selector').querySelectorAll(sel).forEach(b => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      selectedOptions[idx] = btn.dataset.optionValue;
      applyVariant();
    });
  });

  /* ============ QUANTITY ============ */
  const qtyInput = document.getElementById('poloQty');
  if (qtyInput) {
    document.querySelectorAll('[data-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        qtyInput.value = Math.max(1, Math.min(10, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.qty, 10)));
      });
    });
  }

  /* ============ FAQ ============ */
  document.querySelectorAll('.polo-faq__item').forEach(item => {
    const btn = item.querySelector('.polo-faq__q');
    if (btn) btn.addEventListener('click', () => item.setAttribute('aria-expanded', item.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'));
  });

  /* ============ UGC CAROUSEL ============ */
  const ugcRail = document.getElementById('poloUgcRail');
  const ugcPrev = document.getElementById('poloUgcPrev');
  const ugcNext = document.getElementById('poloUgcNext');
  function ugcStep() { if (!ugcRail) return 280; const f = ugcRail.querySelector('.polo-ugc-card'); return f ? f.getBoundingClientRect().width + 14 : 280; }
  function ugcCheck() { if (!ugcRail||!ugcPrev||!ugcNext) return; ugcPrev.disabled=ugcRail.scrollLeft<=4; ugcNext.disabled=ugcRail.scrollLeft+ugcRail.clientWidth>=ugcRail.scrollWidth-4; }
  if (ugcPrev) ugcPrev.addEventListener('click', () => ugcRail.scrollBy({left:-ugcStep(),behavior:'smooth'}));
  if (ugcNext) ugcNext.addEventListener('click', () => ugcRail.scrollBy({left:ugcStep(),behavior:'smooth'}));
  if (ugcRail) ugcRail.addEventListener('scroll', ugcCheck, {passive:true});
  window.addEventListener('resize', ugcCheck);
  ugcCheck();

  /* UGC video play */
  document.querySelectorAll('.polo-ugc-card').forEach(card => {
    const vid = card.querySelector('video');
    const playBtn = card.querySelector('.polo-ugc-card__play');
    if (!vid) return;

    function playVideo() {
      vid.muted = false;
      vid.loop = false;
      vid.controls = true;
      vid.style.zIndex = '3';
      if (playBtn) playBtn.style.display = 'none';
      const p = vid.play();
      if (p) p.catch(() => {
        /* Autoplay blocked: fallback to muted play */
        vid.muted = true;
        vid.play();
      });
    }

    function resetVideo() {
      vid.pause();
      vid.currentTime = 0;
      vid.muted = true;
      vid.loop = true;
      vid.controls = false;
      vid.style.zIndex = '';
      if (playBtn) playBtn.style.display = '';
    }

    if (playBtn) {
      playBtn.addEventListener('click', e => {
        e.stopPropagation();
        playVideo();
      });
    }

    /* Click anywhere on card: play if paused, toggle pause if playing */
    card.addEventListener('click', e => {
      if (playBtn && (e.target === playBtn || playBtn.contains(e.target))) return;
      if (vid.paused) { playVideo(); }
      else { vid.pause(); if (playBtn) playBtn.style.display = ''; }
    });

    /* When video ends, reset to thumbnail state */
    vid.addEventListener('ended', resetVideo);
  });

  /* ============ STICKY CART ============ */
  const sticky = document.getElementById('poloSticky');
  const hero = document.getElementById('polo-hero');
  const finalSec = document.getElementById('polo-final');
  function checkSticky() {
    if (!sticky||!hero) return;
    const b = hero.getBoundingClientRect().bottom;
    const nf = finalSec ? finalSec.getBoundingClientRect().top < window.innerHeight*.7 : false;
    const show = b < 0 && !nf;
    sticky.setAttribute('data-visible', show?'true':'false');
    sticky.setAttribute('aria-hidden', show?'false':'true');
  }
  window.addEventListener('scroll', checkSticky, {passive:true});
  window.addEventListener('resize', checkSticky);
  checkSticky();

  /* ============ ADD TO CART (AJAX) + COMPRAR AGORA ============ */
  const form = document.getElementById('polo-product-form');
  const addBtn = document.getElementById('poloAddToCart');
  const buyBtn = document.getElementById('poloBuyNow');

  function poloToast(msg, isError) {
    let t = document.getElementById('poloToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'poloToast';
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);z-index:9999;padding:12px 20px;border-radius:8px;font-size:14px;font-weight:600;box-shadow:0 4px 16px rgba(0,0,0,.18);opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.background = isError ? '#fdecea' : '#1f8a4c';
    t.style.color = isError ? '#b3261e' : '#fff';
    requestAnimationFrame(() => { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(20px)'; }, 2400);
  }

  const CART_ICON_TRIGGER_SEL = '.push_side[data-id="#nt_cart_canvas"]';
  const CART_DRAWER_SEL = '#nt_cart_canvas';
  const MOBILE_BREAKPOINT = 768;

  function poloIsMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches : window.innerWidth <= MOBILE_BREAKPOINT;
  }

  async function poloBumpCartIcon() {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      document.querySelectorAll('.jsccount').forEach(el => { el.textContent = cart.item_count; });
      document.querySelectorAll('.icon_cart, ' + CART_ICON_TRIGGER_SEL).forEach(el => {
        el.classList.remove('polo-cart-pulse');
        void el.offsetWidth;
        el.classList.add('polo-cart-pulse');
        setTimeout(() => el.classList.remove('polo-cart-pulse'), 700);
      });
      return cart;
    } catch (e) { return null; }
  }

  async function poloHydrateDataIncludes(container) {
    if (!container) return;
    const els = Array.from(container.querySelectorAll('[data-include]'));
    await Promise.all(els.map(async el => {
      const url = el.getAttribute('data-include');
      if (!url) return;
      try {
        let html = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.text());
        const splitMarker = '[split_t4nt]';
        const markerIdx = html.indexOf(splitMarker);
        if (markerIdx !== -1) html = html.slice(0, markerIdx);
        el.innerHTML = html;
      } catch (e) { /* leave as-is on failure */ }
    }));
  }

  async function poloRefreshCartDrawer() {
    try {
      const html = await fetch(window.location.pathname + window.location.search, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(CART_DRAWER_SEL);
      const live = document.querySelector(CART_DRAWER_SEL);
      if (fresh && live) {
        live.innerHTML = fresh.innerHTML;
        await poloHydrateDataIncludes(live);
      }
    } catch (e) { /* non-fatal */ }
  }

  function poloOpenCartDrawer() {
    const trigger = document.querySelector(CART_ICON_TRIGGER_SEL);
    if (trigger && !trigger.classList.contains('act_current')) trigger.click();
  }

  if (!document.getElementById('poloCartPulseStyle')) {
    const style = document.createElement('style');
    style.id = 'poloCartPulseStyle';
    style.textContent = '@keyframes poloCartPulse{0%{transform:scale(1)}30%{transform:scale(1.25)}100%{transform:scale(1)}}.polo-cart-pulse{animation:poloCartPulse .55s ease;}';
    document.head.appendChild(style);
  }

  async function poloAddToCart(btn, { redirectToCart } = {}) {
    if (!form || !btn) return;
    const orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adicionando…';
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const data = await r.json().catch(() => null);
      if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Erro ao adicionar');

      document.dispatchEvent(new CustomEvent('polo:cart:added', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));

      if (redirectToCart) {
        btn.innerHTML = '✓ Adicionado! Indo para o carrinho…';
        window.location.href = '/cart';
        return;
      }

      poloBumpCartIcon();
      if (poloIsMobile()) {
        await poloRefreshCartDrawer();
        poloOpenCartDrawer();
      }

      btn.innerHTML = '✓ Adicionado!';
      poloToast('Produto adicionado ao carrinho.');
      setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 1800);
    } catch (err) {
      btn.innerHTML = 'Erro — tente novamente';
      btn.disabled = false;
      poloToast((err && err.message) || 'Não foi possível adicionar ao carrinho.', true);
      setTimeout(() => { btn.innerHTML = orig; }, 2200);
    }
  }

  if (form && (addBtn || buyBtn)) {
    window.addEventListener('click', (e) => {
      const target = e.target.closest('#poloAddToCart, #poloBuyNow, #poloStickyAdd');
      if (!target) return;
      const wantsBuyNow = target.id === 'poloBuyNow';
      const realTarget = target.id === 'poloStickyAdd' ? addBtn : target;
      if (!realTarget || realTarget.disabled) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); return; }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      poloAddToCart(realTarget, { redirectToCart: wantsBuyNow });
    }, { capture: true });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      const wantsBuyNow = e.submitter && e.submitter.id === 'poloBuyNow';
      poloAddToCart(wantsBuyNow ? buyBtn : (addBtn || e.submitter), { redirectToCart: wantsBuyNow });
    }, { capture: true });
  }

  /* ============ HERO REVIEW CAROUSEL ============ */
  const heroRevs = Array.from(document.querySelectorAll('.polo-hero-review'));
  if (heroRevs.length > 1) {
    let hrCur = 0;
    function showHR(i) { heroRevs.forEach((r,j)=>r.classList.toggle('is-active',j===i)); }
    document.querySelectorAll('.polo-rev-prev').forEach(b=>b.addEventListener('click',()=>{ hrCur=(hrCur-1+heroRevs.length)%heroRevs.length; showHR(hrCur); }));
    document.querySelectorAll('.polo-rev-next').forEach(b=>b.addEventListener('click',()=>{ hrCur=(hrCur+1)%heroRevs.length; showHR(hrCur); }));
  }

  /* ============ PRODUCT DETAIL ACCORDION ============ */
  document.querySelectorAll('.polo-detail-accordion__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const exp = btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded', exp?'false':'true');
      btn.nextElementSibling.hidden = exp;
    });
    btn.addEventListener('keydown', e=>{ if(e.key==='Enter'||e.key===' '){e.preventDefault();btn.click();} });
  });

  /* ============ SIZE GUIDE MODAL ============ */
  const sizeGuideBtn = document.getElementById('poloSizeGuideBtn');
  const sizeModal = document.getElementById('poloSizeModal');
  const sizeClose = document.getElementById('poloSizeClose');
  const sizeBackdrop = document.getElementById('poloSizeBackdrop');
  const sizeFrame = document.getElementById('poloSizeFrame');
  if (sizeGuideBtn && sizeModal) {
    function openSizeModal() {
      if (sizeFrame && sizeGuideBtn.dataset.url && !sizeFrame.src) {
        sizeFrame.src = sizeGuideBtn.dataset.url;
      }
      sizeModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (sizeClose) sizeClose.focus();
    }
    function closeSizeModal() {
      sizeModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      sizeGuideBtn.focus();
    }
    sizeGuideBtn.addEventListener('click', openSizeModal);
    if (sizeClose) sizeClose.addEventListener('click', closeSizeModal);
    if (sizeBackdrop) sizeBackdrop.addEventListener('click', closeSizeModal);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !sizeModal.hasAttribute('hidden')) closeSizeModal();
    });
  }

})();
